import { useParams } from "../Providers/ParamsProvider"

const useCalculateTimeDiff = () => {

  const { availabilityCutoffTime, handleCheckIsWorkingDay } = useParams()

  const diffHoursFromNow = async (inputDateParam) => {
    if (!inputDateParam) {
      return 9999
    }
    const [splitDate] = inputDateParam.split(' ')
    const now = new Date()

    //DK : Ważne aby dodac godziny bo inaczej pobiera now jako np 16 a expectedDeliveryTime zawsze ustawia 2:00 przez co doby zle liczy!!!
    const inputDate = new Date(splitDate)
    inputDate.setHours(now.getHours())
    inputDate.setMinutes(now.getMinutes())
    inputDate.setSeconds(now.getSeconds())
    inputDate.setMilliseconds(now.getMilliseconds())

    const [cutoffHourStr, cutoffMinuteStr] = availabilityCutoffTime.split(':') //Uwzględnienie parametru z datą od kolejnego dnia
    const cutoffHour = parseInt(cutoffHourStr, 10)
    const cutoffMinute = parseInt(cutoffMinuteStr, 10)
    const isAfterCutoff = now.getHours() > cutoffHour || (now.getHours() === cutoffHour && now.getMinutes() > cutoffMinute)

    if (isAfterCutoff) {
      let isTodayIsWorkingDay = false
      do { //dzisiaj musi być pierwszym dniem pracującym!!!
        now.setDate(now.getDate() + 1)
        isTodayIsWorkingDay = await handleCheckIsWorkingDay(now)
      } while (!isTodayIsWorkingDay)
    }

    const diffMs = inputDate.getTime() - now.getTime()
    return diffMs / (1000 * 60 * 60)
  }

  return { diffHoursFromNow }

}

export default useCalculateTimeDiff